export interface DireccionModel {
    tipo_via: string;
    numero_via: string;
    letra_via: string;
    zona_via: string;
    sigo_via: string;
    numero2_via: string;
    letra2_via: string;
    zona2_via: string;
    numero3_via: string;
    observaciones: string;
    direccion_completa: string;
}

export const initValuesDireccionModel = {
    tipo_via: "",
    numero_via: "",
    letra_via: "",
    zona_via: "",
    sigo_via: "#",
    numero2_via: "",
    letra2_via: "",
    zona2_via: "",
    numero3_via: "",
    observaciones: "",
    direccion_completa: "",
}